var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardPaymentMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00089 5.49924H0.997559",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66534 2.16443H2.33145C1.59447 2.16443 0.997559 2.76134 0.997559 3.49832V12.8355C0.997559 13.5725 1.59447 14.1694 2.33145 14.1694H7.667C8.40398 14.1694 9.00089 13.5725 9.00089 12.8355V3.49832C9.00089 2.76134 8.40398 2.16443 7.667 2.16443H6.33311",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3357 11.1682L13.6696 12.5021L12.3357 13.836",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 12.5021H13.6695",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00089 8.18699H0.997559",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66528 0.830566H6.33306V3.49834H3.66528V0.830566Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99785 10.0564C2.93649 10.0564 2.88647 10.1065 2.88713 10.1678C2.88713 10.2292 2.93716 10.2792 2.99851 10.2792C3.05987 10.2792 3.10989 10.2292 3.10989 10.1678C3.10989 10.1065 3.05987 10.0564 2.99785 10.0564",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99858 10.0564C4.93722 10.0564 4.8872 10.1065 4.88787 10.1678C4.88787 10.2292 4.93789 10.2792 4.99924 10.2792C5.06061 10.2792 5.11063 10.2292 5.11063 10.1678C5.11063 10.1065 5.06061 10.0564 4.99858 10.0564",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99931 12.0573C6.93795 12.0573 6.88793 12.1073 6.8886 12.1687C6.8886 12.23 6.93862 12.2801 6.99998 12.2801C7.06134 12.2801 7.11136 12.23 7.11136 12.1687C7.11136 12.1073 7.06134 12.0573 6.99931 12.0573",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99785 12.0573C2.93649 12.0573 2.88647 12.1073 2.88713 12.1687C2.88713 12.23 2.93716 12.2801 2.99851 12.2801C3.05987 12.2801 3.10989 12.23 3.10989 12.1687C3.10989 12.1073 3.05987 12.0573 2.99785 12.0573",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99858 12.0573C4.93722 12.0573 4.8872 12.1073 4.88787 12.1687C4.88787 12.23 4.93789 12.2801 4.99924 12.2801C5.06061 12.2801 5.11063 12.23 5.11063 12.1687C5.11063 12.1073 5.06061 12.0573 4.99858 12.0573",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 4.16528H12.3357C12.7039 4.16528 13.0026 4.46407 13.0026 4.83223V8.16695C13.0026 8.5351 12.7039 8.83389 12.3357 8.83389H9.00098",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 6.16611H13.0026",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99931 10.0564C6.93795 10.0564 6.88793 10.1065 6.8886 10.1678C6.8886 10.2292 6.93862 10.2792 6.99998 10.2792C7.06134 10.2792 7.11136 10.2292 7.11136 10.1678C7.11136 10.1065 7.06134 10.0564 6.99931 10.0564",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPaymentMachine);
export default __webpack_public_path__ + "static/media/credit-card-payment-machine.1cc5f170813b50f8db79b8a049d98cba.svg";
export { ForwardRef as ReactComponent };